module.exports = __webpack_public_path__ + "static/media/29ADMSPC3.12dc3ca0.jpg";